import { GET_DIALSHREE_INBOUND_LEADS, GET_DIALSHREE_INBOUND_LEADS_LOADING, GETDIALSHREE_INBOUND_LEADS_FAILD } from '../type/type';
import axios from "axios";
const PROXY = process.env.REACT_APP_API_URL + 'api/';

export const getAllLeads = (queryObject) => async (dispatch) => {
    try {
        dispatch({ type: GET_DIALSHREE_INBOUND_LEADS_LOADING });
        const res = await axios.get(PROXY + 'dialshree/getInboundCall/', { params: queryObject });
        dispatch({
            type: GET_DIALSHREE_INBOUND_LEADS,
            payload: res.data.result,
        });
        return res;
    }
    catch (err) {
        dispatch({ type: GETDIALSHREE_INBOUND_LEADS_FAILD });
        return err
    }
};

export const getleadViewDetails = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + 'dialshree/' + id);
    return res;
};

export const getAllStatusFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'leads/status/fields');
    return res;
};

export const getFreshWorkFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/freshworkBrand/fields');
    return res;
};

export const getleadDetails = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + 'leads/getLeadJourney/' + id);
    return res;
};

export const getPincodeDirectoryFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/pincode-directory/fields');
    return res;
};

export const getTenureDownpayRangeFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/tenure-downpay-range/fields');
    return res;
};

export const downloadLeads = (queryParams, leadType) => async (dispatch) => {
    try {
        const filteredParams = Object.entries(queryParams)
            .filter(([_, value]) => value !== undefined && value !== null && value !== '')
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

        const searchParams = new URLSearchParams(filteredParams);

        // Return the axios promise directly
        return await axios.get(`${PROXY}leads/download/csv/${leadType}?${searchParams.toString()}`);
    }
    catch (err) {
        throw err;  // Rethrow the error so it can be caught in the .catch block
    }
};

export const uploadleads = (formData) => async (dispatch) => {
    const res = await axios.post(`${PROXY}` + `leads/upload/csv`, formData);
    return res;
};


export const getInboundUniqueFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'dialshree/filterFieldsInboundCall');
    return res;
};

export const getGoogleSignedRecordingUrl = (id) => async (dispatch) => {
    try {
        const res = await axios.get(PROXY + 'dialshree/getGoogleSignedRecording/' + id);
        return res.data;
    } catch (error) {
        console.error("Error fetching Google signed recording URL:", error);
        throw error; // Rethrow the error for further handling
    }
}
